const modelRegistry = {};
let isInitialized = false;

export const initializeModels = async () => {
  if (isInitialized) {
    return modelRegistry;
  }
  isInitialized = true;

  const modules = require.context("../../../app/models", false, /\.js$/);

  modules.keys().forEach((path) => {
    const module = modules(path); // Load the module synchronously
    const ModelClass = module.default;

    if (ModelClass) {
      // Derive model name from file path (e.g., "user.js" -> "users")
      const modelName = path.split("/").pop().replace(".js", "").toLowerCase();

      modelRegistry[modelName] = ModelClass;
    }
  });

  return modelRegistry;
};
